import { TECHNIC_PREFIX } from '../../../config/technicPrefix';
import { urls } from '../../../config/url';
import { ILines } from '../../../redux/progress/line/lineReducer';
import httpRequest from '../../../utils/HttpRequest';

export default function useUpdateLine(userName: string, projectName: string, updateLines: (lines: ILines) => void, tech: string): () => Promise<ILines> {
    function update() {
        return httpRequest(urls.listProjectTechProj, {
            USER_NAME: userName,
            PROJECTNAME: projectName,
            TECHNIC_PREFIX: (TECHNIC_PREFIX as any)[tech]
        }).then(res => {
            if (res.data.errno === 0) {
                const linesArray: string[] = res.data.data;
                const lines: ILines = {};

                for (let line of linesArray) {
                    lines[line] = line;
                }

                return lines;
            } else {
                throw new Error(res.data.errmsg);
            }
        }).then(lines => {
            updateLines(lines);
            return lines
        });
    }
    return update
}